import { MultiSelectOptionValue } from '@collector/shared-ui'
import { toValue } from '@collector/shared-utils'
import { Incident } from '@collector/sportsapi-client'
import { IncidentAttributeId } from '@collector/sportsapi-client-legacy'
import { injectHistoryIncidentsConfig } from '@desktop/views/Relation/Sports/provide-inject'

export function useHistoryIncidentSettings(incident: Incident): {
  attributeIds: IncidentAttributeId[] | undefined
  attributesSelectionConstraint?: (
    newSelection: MultiSelectOptionValue[],
    previousSelection: MultiSelectOptionValue[],
  ) => MultiSelectOptionValue[]
  singleAttributes: boolean
  displayInfo?: string
  swappable: boolean
} {
  // inject
  const historyIncidentsConfig = injectHistoryIncidentsConfig() || {}

  // data
  const attributeIds = toValue(
    historyIncidentsConfig[incident.incident_id]?.attributeIds,
    incident,
  )

  const singleAttributes =
    !!historyIncidentsConfig[incident.incident_id]?.singleAttributes

  const swappable =
    toValue(
      historyIncidentsConfig[incident.incident_id]?.swappable,
      incident,
    ) ?? true

  const attributesSelectionConstraint =
    historyIncidentsConfig[incident.incident_id]?.attributesSelectionConstraint

  const displayInfo = historyIncidentsConfig[incident.incident_id]?.displayInfo

  return {
    attributeIds,
    attributesSelectionConstraint,
    singleAttributes,
    swappable,
    displayInfo,
  }
}
